

export default (limit) => ({
    limit,
    nextPageUrl: '',
    pageData: [],
    preloaded: [],
    async getPage(url) {
        const data = await window.api.get(`${url}&limit=${this.limit}`).then((response) => response.data)

        if (
            typeof data !== 'object'
            && !Array.isArray(data)
        ) {
            this.stopFetching()
            return []
        }

        return data
    },
    async startPagination(url) {
        const separator = url.includes('?') ? '&' : '?'
        const response = await this.getPage(`${url}${separator}page=1`)
        this.pageData = this.convertIfObject(response.data)

        // Page 2's address only: the caller preloads it (preloadNextPage) once page 1 is showing, rather than page 1
        // waiting another round trip for it. An array means there's just the one page.
        this.nextPageUrl = (response.pagination && !Array.isArray(response.pagination)) ? response.pagination.next : false
    },
    stopFetching() {
        this.preloaded = []
        this.nextPageUrl = false
    },
    async preloadNextPage(url) {
        const response = await this.getPage(url)
        this.nextPageUrl = response.pagination ? response.pagination.next : false
        this.preloaded = response.data
    },
    async loadNextPage() {
        if (!this.nextPageUrl) {
            return false
        }

        this.pageData = this.pageData.concat(this.convertIfObject(this.preloaded))
        this.preloaded = []

        if (this.nextPageUrl.endsWith('page=1')) {
            this.stopFetching()
            return false
        }

        await this.preloadNextPage(this.nextPageUrl)
        return true
    },
    convertIfObject(potentialObject) {
        if (typeof potentialObject === 'object') {
            return Object.values(potentialObject)
        }

        if (Array.isArray(potentialObject)) {
            return potentialObject
        }

        return []
    },
})
